// extracted by mini-css-extract-plugin
export default {"outer":"MemoryMap_outer__zZM93","map":"MemoryMap_map__iHL5k","legend":"MemoryMap_legend__KJVix","label":"MemoryMap_label__y8Ov-","swatch":"MemoryMap_swatch__RPJbg"};